"use strict";

var url = require('url');

var RemoteFile = require('./remoteFile');

var LocalFile = require('./localFile');

function fromUrl(source) {
  var _url$parse = url.parse(source),
      protocol = _url$parse.protocol,
      pathname = _url$parse.pathname;

  if (protocol === 'file:') {
    return new LocalFile(unescape(pathname));
  }

  return new RemoteFile(source);
}

module.exports = {
  LocalFile: LocalFile,
  RemoteFile: RemoteFile,
  fromUrl: fromUrl,
  open: function open(maybeUrl, maybePath, maybeFilehandle) {
    if (maybeFilehandle) return maybeFilehandle;
    if (maybeUrl) return fromUrl(maybeUrl);
    if (maybePath) return new LocalFile(maybePath);
    throw new Error('no url, path, or filehandle provided, cannot open');
  }
};